// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
._v564ybtr{transition:all .3s}._154iidpf{top:0}
._1bsb1osq{width:100%}
._1ltvidpf{left:0}
._4t3i1osq{height:100%}
._bfhk326j{background-color:var(--_1ox8nit)}
._c71l1osq{max-height:100%}
._kqswstnw{position:absolute}
._p12f1osq{max-width:100%}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/media-card/dist/esm/card/ui/blanket/blanket-compiled.compiled.css"],"names":[],"mappings":";AACA,WAAW,kBAAkB,CAAC,WAAW,KAAK;AAC9C,WAAW,UAAU;AACrB,WAAW,MAAM;AACjB,WAAW,WAAW;AACtB,WAAW,gCAAgC;AAC3C,WAAW,eAAe;AAC1B,WAAW,iBAAiB;AAC5B,WAAW,cAAc","sourcesContent":["\n._v564ybtr{transition:all .3s}._154iidpf{top:0}\n._1bsb1osq{width:100%}\n._1ltvidpf{left:0}\n._4t3i1osq{height:100%}\n._bfhk326j{background-color:var(--_1ox8nit)}\n._c71l1osq{max-height:100%}\n._kqswstnw{position:absolute}\n._p12f1osq{max-width:100%}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
